import { workerRegistry } from '@/lib/agents/registry'
import { NodeProps } from '@xyflow/react'
import { Scissors } from "lucide-react"
import { InlineHandles, WorkerLabeledHandle } from '../handles'
import { useWorker } from '../hooks'
import { MemoizedWorker } from '../memoizedworkers'
import { NodeLayout } from './node'
import { MultiSelect } from '@/components/ui/multi-select'
import { useState, useEffect } from 'react'

const { extraction } = workerRegistry

extraction.icon = Scissors

const fileTypeOptions = [
  { label: "PDF", value: "pdf" },
  { label: "DOC", value: "doc" },
  { label: "DOCX", value: "docx" },
  { label: "XLSX", value: "xlsx" },
  { label: "CSV", value: "csv" },
  { label: "TXT", value: "txt" },
  { label: "PNG", value: "png" },
  { label: "JPG", value: "jpg" },
  { label: "JPEG", value: "jpeg" },
  { label: "GIF", value: "gif" },
  { label: "MP3", value: "mp3" },
  { label: "MP4", value: "mp4" },
  { label: "OGG", value: "ogg" },
]

function Parameters({ worker }: { worker: ExtractionWorker }) {
  const [selectedFileTypes, setSelectedFileTypes] = useState<string[]>(worker.parameters.fileTypes || [])

  useEffect(() => {
    worker.parameters.fileTypes = selectedFileTypes
  }, [selectedFileTypes, worker])

  return <div className='px-2 nodrag w-full grow flex flex-col py-2'>
    <label className='text-xs font-medium text-gray-600 mb-1'>File Types</label>
    <MultiSelect
      options={fileTypeOptions}
      onValueChange={setSelectedFileTypes}
      defaultValue={selectedFileTypes}
      placeholder="Select file types..."
      maxCount={5}
    />
  </div>
}

export function ExtractionNode(props: NodeProps) {
  const worker = useWorker<ExtractionWorker>(props.id)

  return <NodeLayout worker={worker} resizable minHeight={250} minWidth={300} className='flex flex-col'>

    <InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.input} />
      <WorkerLabeledHandle handler={worker.fields.cleanText} />
    </InlineHandles>

    <WorkerLabeledHandle handler={worker.fields.files} />
    <WorkerLabeledHandle handler={worker.fields.quickReplies} />

    <MemoizedWorker worker={worker} name="parameters">
      <Parameters worker={worker} />
    </MemoizedWorker>

  </NodeLayout>
}
